import React from 'react';

import { connect, useSelector } from 'react-redux'

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContentWithDetails from '../../containers/pageContentWithDetails'

import ToolsTable from './ToolsTable'
import ToolsDetails from './ToolsDetails'
import CardHeader from '../../containers/CardHeader'

import { Card } from 'react-bootstrap'
import { FaPlus } from "react-icons/fa";
import InvalidPermissions from '../../containers/InvalidPermissions'

const ToolsSection = (props) => {
    const isSysadmin = useSelector((state) => state.user.isSysadmin)
    const companyID = useSelector((state) => state.user.company.id)
    const hasCompanyAccess = parseInt(companyID) === 39 // client_tools access granted to this company only
    const title = "Client Tools";
    const subtitle = "Listing of all Client Tools"
    const headerAction = isSysadmin ? {'path': "/tools/add", 'icon':FaPlus} : {}

    if(!isSysadmin && !hasCompanyAccess) return <InvalidPermissions />
    return (
        <>
        <Card>
            <CardHeader title={title} description={subtitle} action={headerAction} />
            <ToolsTable showDetailsOnClick={true} />
        </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContentWithDetails(ToolsSection, ToolsDetails), "Tools"));
